import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Checkbox,
  FormControlLabel,
  List,
} from "@mui/material";
import {
  NoteAdd as NoteAddIcon,
  ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";

import { changeExpansion } from "app/store/transmission/slice/transmissionSlice";

import ReportTask from "./ReportTask";
import LoadingSpinner from "components/LoadingSpinner";
import { useGetReportTasksQuery } from "app/store/transmission/api/transmissionDetailApi";

import useReportTasks from "components/pages/transmissions/modal/detail/notes/task/useReportTasks";
import ReportTaskForm from "components/pages/transmissions/modal/detail/notes/task/ReportTaskForm";

const ReportTasks = ({ data }) => {
  const {
    tasksExpanded,
    theme,
    dispatch,
    handleEdit,
    task,
    setTask,
    initialTask,
    handleInputChange,
    handleTask,
    hasAuditAccess,
    handleAudit,
    isAudited,
  } = useReportTasks(data);

  const {
    data: tasks,
    isFetching,
    isLoading,
  } = useGetReportTasksQuery({
    reportId: data?._id,
    account: data?.account,
    showAuditedReport: hasAuditAccess,
  });

  return (
    <Accordion
      className="view-pdf__panel"
      expanded={tasksExpanded}
      onChange={(e, expanded) => {
        e.preventDefault();
        setTask(initialTask);
        dispatch(changeExpansion({ type: "tasks", value: expanded }));
      }}
      style={{
        boxShadow: "none",
        marginBottom: "20px",
        borderColor:
          theme.palette.type === "dark"
            ? "rgba(255, 255, 255, 0.12)"
            : "#E0E0E0",
      }}
    >
      <AccordionSummary
        expandIcon={
          <ExpandMoreIcon data-action="expand-more-report-tasks-icon" />
        }
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <span className="view-pdf__notes-header--icon" style={{ margin: 0 }}>
          <NoteAddIcon />
        </span>
        <div className="view-pdf__notes-header--title" style={{ margin: 0 }}>
          Tasks {tasks?.length > 0 && `(${tasks?.length})`}
        </div>
      </AccordionSummary>
      <AccordionDetails className="view-pdf__details">
        <>
          {isFetching || isLoading ? (
            <div style={{ padding: "50px 0", textAlign: "center" }}>
              <LoadingSpinner color="secondary" />
            </div>
          ) : tasks?.length > 0 ? (
            <List
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {tasks?.map((task, index) => {
                return (
                  <ReportTask
                    key={index}
                    task={task}
                    index={index}
                    handleEdit={handleEdit}
                  />
                );
              })}
            </List>
          ) : (
            <div style={{ marginBottom: "10px" }}>No tasks available</div>
          )}

          <ReportTaskForm
            data={data}
            isFetching={isFetching || isLoading}
            task={task}
            handleInputChange={handleInputChange}
            onSubmit={handleTask}
            onCancel={() => setTask(initialTask)}
          />

          {hasAuditAccess && (
            <>
              <Alert severity="info" className="info-alert mt-2 mb-2">
                Audited report will be sent for review
              </Alert>

              <div className="d-flex align-items-center flex-end">
                <FormControlLabel
                  label="Mark as Audited"
                  labelPlacement="end"
                  margin
                  control={
                    <Checkbox
                      name="audited_report"
                      checked={isAudited || false}
                      onChange={(event) => handleAudit(event.target.checked)}
                      sx={{
                        padding: 0,
                        color: "#fff",
                        "&.Mui-checked": { color: "#fff" },
                      }}
                    />
                  }
                  className="mt-2"
                  style={{
                    backgroundColor: "#94BA33",
                    color: "#fff",
                    padding: "8px 12px",
                    borderRadius: "4px",
                    fontSize: "16px !important",
                    fontWeight: "500 !important",
                    fontFamily: "Roboto !important",
                    gap: "4px",
                    margin: 0,
                  }}
                />
              </div>
            </>
          )}
        </>
      </AccordionDetails>
    </Accordion>
  );
};

export default ReportTasks;
